"use client";

import { cn } from "@/lib/utils";

interface WowActionButtonProps
  extends Omit<React.ComponentProps<"button">, "children"> {
  /** Path to a Blizzard icon (see WOW_ICONS). */
  icon: string;
  /** Small keybind text rendered in the top-right corner. */
  hotkey?: string;
  /** While true the button pulses with a golden casting glow. */
  casting?: boolean;
  /** 0–100; darkens the un-swept part of the icon like a cooldown. */
  sweepPercent?: number;
  label: string;
}

export function WowActionButton({
  icon,
  hotkey,
  casting = false,
  sweepPercent,
  label,
  className,
  ...props
}: WowActionButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      data-casting={casting}
      className={cn("wow-action-btn", className)}
      style={{ backgroundImage: `url(${icon})` }}
      {...props}
    >
      {sweepPercent !== undefined && sweepPercent < 100 ? (
        <span
          aria-hidden
          className="wow-action-sweep"
          style={{ "--wow-sweep": sweepPercent } as React.CSSProperties}
        />
      ) : null}
      {hotkey ? <span className="wow-action-hotkey">{hotkey}</span> : null}
    </button>
  );
}
